

<template>
  <div class="d-flex">

 
  <div class="head-count" >
    <tl-header type="h3" class="title">Payroll</tl-header>
    <div :disabled="!ifTeamleaderAnchorPermission">
      <div class="quarter financialYears">
        <!-- <img
          class="prevFYyear"
          src="@/assets/path-2-copy.png"
          @click="onPrevFYClick()"
          v-show="currentFinancialYearIndex > 0"
        /> -->
        <div class="label">
          <b>FY</b>
        </div>
        <div class="dot">
          <b>.</b>
        </div>
        <div class="year">
          {{ payrollFinancialYear }}
          <!-- {{ ( financialYearsList.length && (currentFinancialYearIndex > -1) &&
          financialYearsList[0].name ) ?
          financialYearsList[0].name : "" }} -->
        </div>
        <!-- <img
          class="nextFYyear"
          src="@/assets/next-icon.png"
          @click="onNextFYClick()"
          v-show="currentFinancialYearIndex < (financialYearsList.length - 1)"
        /> -->
      </div>
      <toast-message
        :message="errmsg"
        type="error"
        :isToastEnable="toast"
        @close="(val) => toast = val"
      />
      <div class="quartermonths financialYears">
        <!-- <img
          class="prevmonth"
          src="@/assets/path-2-copy.png"
          @click="onPrevMonthClick()"
          v-show="currentMonthIndex > 0"
        /> -->
        <div
          v-for="(mon, index) in payrollMonths[currentMonthIndex]"
          :key="index"
          :class="{'selected':selectmonth==mon.name,'month':true}"
          v-on:click="onMonthSelection(mon.name)"
        >
          <div>
            <span>{{ mon.name }}</span>
            <span class="subtext">{{ selectYear }}</span>
            <img v-if="mon.locked" src="@/assets/lock.svg" class="lock" />
            <img v-if="!mon.locked && mon.paydate" src="@/assets/group-49.svg" class="lock" />
          </div>
          <div v-if="mon.paydate && currentmonth()==mon.name" class="paydate">
            <span>Run date:</span>
            {{mon.paydate}}
          </div>
        </div>
        <!-- <img
          class="nextmonth"
          src="@/assets/next-icon.png"
          @click="onNextMonthClick()"
          v-show="currentMonthIndex < (payrollMonths.length - 1)"
        /> -->
      </div>

      <div class="run">
        <!-- <btn
          text="FBP Lock"
          class="purple"
          type="primary"
          @click="redirectToFbpLock"
        ></btn>
        <btn
          text="LOCK PAYROLL MONTH"
          type="secondary"
          v-show="!selectmonth.locked"
          @click="confirm"
        ></btn>
        <btn
          text="UNLOCK PREVIOUS MONTH"
          type="primary"
          v-show="ifSuperAdmin || ifTeamleaderAnchorPermission"
          @click="unlockPayroll"
          class="purple"
          v-if="!ifAdmin"
        ></btn> -->
        <btn :text="btnText" type="primary" @click="onRunPayrollClick(btnText)" :disabled="!statutoryFlag" class="purple"></btn>
        <!-- <btn text="Release Payslip to ESS" type="secondary" @click="onReleasePayslip"></btn> -->
        <btn v-show="incorporationDate" text="Release IT Proof for payroll" type="primary" @click="functiontoCheckEmployeeSavedAsDraft()"></btn>
        <tl-checkbox :disabled="itProofReleasedForThisMonthPayroll" v-show="!incorporationDate" style="margin:15px;" label="Enable Incorporation" v-model="incorporationDate" @change="!incorporationDate"></tl-checkbox>
        <!-- <btn text="RUN OFF CYCLE PAYROLL" type="secondary" @click="runOffCyclePayroll()" ></btn> -->
      </div>

      <div class="bottom">
        <div>
          <p>
            <span>Gross Pay:</span>
            <br />
            <span>
              <b>{{ grossPay }}</b>
            </span>
          </p>
        </div>
        <div>
          <p>
            <span>Deductions:</span>
            <br />
            <span>
              <b>{{ totalDeduction }}</b>
            </span>
          </p>
        </div>
        <div>
          <p>
            <span>Total Pay:</span>
            <br />
            <span>
              <b>{{ totalPay }}</b>
            </span>
          </p>
          <p class="increase">
            <b>0%</b> Since
            <br />Last month
          </p>
        </div>
      </div>
      <div class="reports" v-show="!selectmonth.locked">
        <div @click="publishReports" class="disabledMode">
          <b>Publish Reports to ESS</b>
        </div>
        <div @click="viewReports">
          <b>Download Payroll Reports</b>
        </div>
      </div>
    </div>

    <pop-up-message
        v-if="showSuccessMsg"
        :message="successMessage"
        :popupType="'Success'"
        popupHeaderMessage="Success"
      >
        <template v-slot:bottomContent>
        <div class="popup-btn-group">
          <button class="btn-popup-secondary" type="button" @click="gotoPayroll">
            <b>Back</b>
          </button>
        </div>
      </template>
    </pop-up-message>
    <pop-up-message
      popupHeaderMessage="Warning"
      v-if="incorporationDateIsDraftValidation"
      :message=incorporationValidationMessage
      :popupType="'Warning'"
    >
      <template v-slot:bottomContent>
        <div class="popup-btn-group">
          <button class="btn-popup-secondary" type="button" @click="cancel('checkIsAuditApproved')">
            <b>Cancel</b>
          </button>
          <button v-show="auditPendingFlag" class="btn-popup" type="button" @click="()=>{
             incorporationDateIsDraftValidation = !incorporationDateIsDraftValidation;
             releaseItProofForThisMonthPayrollFlag=!releaseItProofForThisMonthPayrollFlag;
             releaseItProofForThisMonthPayroll()
             }">
            <b>Confirm</b>
          </button>
        </div>
      </template>
    </pop-up-message>
    <pop-up-message
      popupHeaderMessage="Warning"
      v-if="releaseItProofForPayroll"
      message="Are you sure  you want to release IT Proof for this month Payroll"
      :popupType="'Warning'"
    >
      <template v-slot:bottomContent>
        <div class="popup-btn-group">
          <button class="btn-popup-secondary" type="button" @click="cancel()">
            <b>Cancel</b>
          </button>
          <button class="btn-popup" type="button" @click="releaseItproofValidation">
            <b>Confirm</b>
          </button>
        </div>
      </template>
    </pop-up-message>
    <pop-up-message
        v-if="showSuccessMsg"
        :message="successMessage"
        :popupType="'Success'"
        popupHeaderMessage="Success"
      >
        <template v-slot:bottomContent>
        <div class="popup-btn-group">
          <button class="btn-popup-secondary" type="button" @click="gotoPayroll">
            <b>Back</b>
          </button>
        </div>
      </template>
    </pop-up-message>
    <pop-up-message
      popupHeaderMessage="Warning"
      v-if="showLockPopup"
      message="Are you sure  you want to Lock this month Payroll"
      :popupType="'Warning'"
    >
      <template v-slot:bottomContent>
        <div class="popup-btn-group">
          <button class="btn-popup-secondary" type="button" @click="cancel()">
            <b>Cancel</b>
          </button>
          <button class="btn-popup" type="button" @click="yes">
            <b>Yes</b>
          </button>
        </div>
      </template>
    </pop-up-message>

    <pop-up-message
      popupHeaderMessage="Warning"
      v-if="showUnlockPopup"
      :popupType="'Warning'"
      class="popupClass"
    >
      <template v-slot:bottomContent>
        <span class="popupdetails">Reason To Unlock Payroll</span>
        <txt type="textarea" class="custom-width" rows="5" />
        <div class="popup-btn-group">
          <button class="btn-popup-secondary" type="button" @click="cancelUnlockPayroll()">
            <b>Cancel</b>
          </button>
          <button class="btn-popup" type="button" @click="submitUnlockPayroll">
            <b>Submit</b>
          </button>
        </div>
      </template>
    </pop-up-message>

    <pop-up-message
      v-if="unlockMonthPopup"
      popupType="Warning"
      popupHeaderMessage="Warning"
      message="You Need to Lock Previous month Payroll to proceed."
      btnText="Back"
      @back="back"
    />

    <pop-up-message
      popupHeaderMessage="Warning"
      v-if="showLockPopupModal"
      message="Are you sure you want to Lock this month Payroll"
      :popupType="'Warning'"
    >
      <template v-slot:bottomContent>
        <div class="popup-btn-group">
          <button class="btn-popup-secondary" type="button" @click="no">
            <b>No</b>
          </button>
          <button class="btn-popup" type="button" @click="lockPayroll">
            <b>Yes</b>
          </button>
        </div>
      </template>
    </pop-up-message>

    <pop-up-message
      popupHeaderMessage="Warning"
      v-if="showReleasePayslip"
      :message=popupmessage
      :popupType="'Warning'"
    >
      <template v-slot:bottomContent>
        <div class="popup-btn-group">
          <button class="btn-popup-secondary" type="button" @click= "cancelRelease">
            <b>No</b>
          </button>
          <button class="btn-popup" type="button" @click="releasePayslip">
            <b>Yes</b>
          </button>
        </div>
      </template>
    </pop-up-message>
    <pop-up-message
      popupHeaderMessage="Warning"
      v-if="showReleaseITSheet"
      :message=popUpMessage
      :popupType="'Warning'"
    >
      <template v-slot:bottomContent>
        <div class="popup-btn-group">
          <button class="btn-popup-secondary" type="button" @click= "cancelReleaseITSherrt">
            <b>No</b>
          </button>
          <button class="btn-popup" type="button" @click="releaseITSheet">
            <b>Yes</b>
          </button>
        </div>
      </template>
    </pop-up-message>
     <pop-up-message
      popupHeaderMessage="Warning"
      v-if="showIncorporateDeclaration"
      :message=popupmessage
      :popupType="'Warning'"
    >
      <template v-slot:bottomContent>
        <div class="popup-btn-group">
          <button class="btn-popup-secondary" type="button" @click= "cancelIncorporation">
            <b>No</b>
          </button>
          <button class="btn-popup" type="button" @click="functiontoIncorporateDeclaration1">
            <b>Yes</b>
          </button>
        </div>
      </template>
    </pop-up-message>
    <generate-payroll-report-popup :warningMessage="'You can release the payslip and IT sheets only after they have been generated for all employees.*'"   @selectedEmployeesFlag="handleSelectedEmployeesFlag" :generatePayload="generatePayload" v-if="showReportModal" @closeReportModal="closeReportModal"></generate-payroll-report-popup>
    <!-- <generate-payroll-report-popup :generatePayload="generatePayload" v-if="showReportModal" @closeReportModal="closeReportModal"></generate-payroll-report-popup> -->
    <div v-show="showPublishPopup">
      <div class="modal">
        <div class="modal-content-history">
          <div class="top-bar">
            <span>Publish Reports</span>
          </div>
          <div class="popupRadios">
            <tl-radio
              label="Publish Payslips"
              name="publishType"
              id="publishType"
              value="payslips"
              v-model="publishType"
              @change="(val)=>publishType=val"
            />

            <tl-radio
              label="Publish IT Sheets"
              name="publishType"
              id="publishType"
              value="itsheet"
              v-model="publishType"
              @change="(val)=>publishType=val"
            />
          </div>
          <div class="popupradio">
            <tl-radio
              label="Both"
              name="publishType"
              v-model="publishType"
              id="publishType"
              value="both"
              @change="(val)=>publishType=val"
            />
          </div>
          <btn-grp class="btnGrp">
            <btn text="Cancel" type="secondary" @click="cancelAdd" />
            <btn text="Submit" type="primary" @click="addPopup" />
          </btn-grp>
        </div>
      </div>
    </div>

    <div class="Total_list">
     
      <div class="Active_list">
        <tl-header type="h3" class="title">
            Active Lists
    </tl-header>
      <table >
        <thead>
          <tr>
            <th>Date</th>
            <th>Name</th>
            <th>Month</th>
            <th>Year</th>
            <th>Progress bar</th>
            <th>Head Count</th>
          </tr>
        </thead>
        <tbody id="Actives">
          <tr v-for="item in actives.slice(0,10)" :key="item.id">
            <td>{{new Date(item.processedOn).getDate()}}/{{new Date(item.processedOn).getMonth() + 1}}/{{new Date(item.processedOn).getFullYear()}}</td>
            <td>{{item.data.legal_entity_name}}</td>
            <td>{{ item.data.month }}</td>
            <td>{{ item.data.financial_year }}</td>
            <td> 
              <div class="active-bar">
                <progress :value="item.progress" max="100" style="appearance: none; position: relative;" :data-label="item.progress">
                </progress>{{ item.progress }}%
              </div>
            </td>
            <!-- <td></td> -->
            <td>{{ item.data.total_employees }}</td>
          </tr> 
        </tbody>
      </table>
    </div>
    <div class="Completed_list">
      <tl-header type="h3" class="title">
            Completed Lists
    </tl-header>
      <table >
        <thead>
          <tr>
            <th>Date</th>
            <th>Name</th>
            <th>Month</th>
            <th>Year</th>
            <th>Progress bar</th>
            <th>status</th>
          </tr>
        </thead>
        <tbody id="Completed">
          <tr v-for="item in completed.slice(0,10)" :key="item.id">
            <td>{{new Date(item.processedOn).getDate()}}/{{new Date(item.processedOn).getMonth()+1}}/{{new Date(item.processedOn).getFullYear()}}</td>
            <td>{{item.data.legal_entity_name}}</td>
            <td>{{ item.data.month }}</td>
            <td>{{ item.data.financial_year }}</td>
            <td class="complete-bar"><progress :value="item.progress" max="100" style="appearance: none;"></progress></td>
            <td>Completed</td>
          </tr> 
        </tbody>
      </table>
    </div>
  </div>
  </div>
  <div class="quick-links">
    <tl-header type="h3" class="title">Actions</tl-header>
     <div class="runie">
        <button class="mt-2 mb-2 customButton" @click="generateReports()">Generate Payroll Reports</button>
        <button
          class="mt-2 mb-2 customButton"
         
          @click="redirectToFbpLock"
        > 
        FBP Lock
      </button>
        <button
        class="mt-2 mb-2 customButton"
          
          v-show="!selectmonth.locked"
          @click="confirm"
        >LOCK PAYROLL MONTH</button>
        <button
        class="mt-2 mb-2 customButton"
          
          v-show="ifSuperAdmin || ifTeamleaderAnchorPermission"
          @click="unlockPayroll"
          
          v-if="!ifAdmin"
        >
        UNLOCK PREVIOUS MONTH
      </button>
        <!-- <btn :text="btnText" type="secondary" @click="onRunPayrollClick(btnText)" :disabled="!statutoryFlag" class="purple"></btn> -->
        <button class="mt-2 mb-2 customButton" @click="onReleasePayslip">Release Payslip to ESS</button>
        <button class="mt-2 mb-2 customButton" @click="onReleaseITSheet">Release IT Sheet to ESS</button>
        <!-- Disabling "Release IT Proof for payroll" based on ticket no HCM-1042 -->
        <!-- <button class="mt-2 mb-2 customButton" :disabled="true"  @click="functiontoCheckEmployeeSavedAsDraft()">Release IT Proof for payroll</button> -->
        <button class="mt-2 mb-2 customButton" :disabled="!declarationFlag" @click="onIncorporateDeclaration()">Release IT Declaration for payroll</button>
        
        <!-- <tl-checkbox class="mt-1 mb-1" :disabled="itProofReleasedForThisMonthPayroll" v-show="!incorporationDate" style="margin:15px;" label="Enable Incorporation" v-model="incorporationDate" @change="!incorporationDate"></tl-checkbox> -->
        <!-- <btn text="RUN OFF CYCLE PAYROLL" type="secondary" @click="runOffCyclePayroll()" ></btn> -->
      </div>
  </div>
 </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import {
  eventBus
} from '@/main';
import generatePayrollReportPopup from './generatePayrollReportsPopUp.vue'

export default {
  components: {
    generatePayrollReportPopup
  },
  data() {
    return {
      showReportModal: false,
      generatePayload: {

      },
      showReportModal: false,
      generatePayload: {

      },
      socket: null,
      toast: false,
      errmsg: "",
      payrollMonths: [
        [{ name: "April", isEnable: false }],
        [{ name: "May", isEnable: false }],
        [{ name: "June", isEnable: false }],
        [{ name: "July", isEnable: false }],
        [{ name: "August", isEnable: false }],
        [{ name: "September", isEnable: false }],
        [{ name: "October", isEnable: false }],
        [{ name: "November", isEnable: false }],
        [{ name: "December", isEnable: false }],
        [{ name: "January", isEnable: false }],
        [{ name: "February", isEnable: false }],
        [{ name: "March", isEnable: false }]
      ],
      incorporationDate: false,
      declarationFlag:false,
      enableITProofReleaseButton:false,
      releaseItProofForPayroll:false,
      IncorporationValidationData:{},
      incorporationValidationMessage:"",
      incorporationDateIsDraftValidation:false,
      releaseItProofForThisMonthPayrollFlag:true,
      itProofReleasedForThisMonthPayroll:false,
      auditPendingFlag:true,
      selectmonth: "",
      selectYear: "",
      showLockPopup: false,
      showUnlockBtn: false,
      showReleasePayslip: false,
      showReleaseITSheet: false,
      showIncorporateDeclaration:false,
      popupmessage: null,
      popUpMessage: null,
      showSuccessMsg : false,
      successMessage: null,
      showUnlockPopup: false,
      unlockMonthPopup: false,
      showPublishPopup: false,
      publishType: "payslips",
      firstPayrollDate: null,
      financialYearsList: [],
      currentFinancialYearIndex: 0,
      currentMonthIndex: 0,
      grossPay: 0,
      totalDeduction: 0,
      totalPay: 0,
      payrollDashboardsValue: false,
      role: "",
      showLockPopupModal: false,
      previousPayrollMonth: "",
      previousMonth: null,
      statutoryFlag: true,
      actives: [],
      completed: [],
    };
  },
  computed: {
    ...mapState({
      payrollMonth: state => state.payroll.runpayroll.payrollMonth,
      payrollYear: state => state.payroll.runpayroll.payrollYear,
      entities: state => state.onboard.legal_entities.data
    }),
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    le_id() {
      if (this.$route.params.entity_index) {
        return this.getleid(this.$route.params.entity_index);
      }
      return this.getleid(0);
    },
    isLoading() {
      return this.isFetching;
    },
    btnText: function() {
      if (this.selectmonth.locked) {
        return "UNLOCK PAYROLL";
      }
      return "RUN PAYROLL";
    },
    payrollFinancialYear() {
      if (this.currentMonthIndex > 8) {
        localStorage.setItem("financialYear",`${ this.selectYear - 1 }-${ this.selectYear }`)
        return `${ this.selectYear - 1 } - ${ this.selectYear }`
      } else {
        localStorage.setItem("financialYear",`${ this.selectYear }-${ Number(this.selectYear) + 1 }`)
        return `${ this.selectYear } - ${ Number(this.selectYear) + 1 }`
      }
    },
    ...mapState("onboard/organization", {
      orgIds: state => state.id,
    }),
    ifTeamleaderAnchorPermission() {
      if(this.role === 'TEAMLEADER' || this.role === 'ANCHOR' || this.role === 'ADMIN') {
        if(this.payrollDashboardsValue) {
        return true;
        } else {
          return false;
        }
      } 
      // else {
      //  return true 
      // }
    },
    ifSuperAdmin() {
      return localStorage.getItem("userRole") == "SUPERADMIN" ? true : false;
    },
    ifAdmin() {
      return localStorage.getItem("userRole") == "ADMIN" ? true : false;
    }
  },
  activated() {
    this.selectmonth = "";
    this.getLockedPayrollMonth();
    this.statutorySettingCheck();
    this.fetchIncorporation();
    this.fetchDeclarationFlag()

  },
  mounted() {
    this.selectmonth = "";
    this.fetchIncorporation();
    this.fetchDeclarationFlag()
    this.getLockedPayrollMonth();
    this.fetchPayrollCycleData();
    this.getPayData();
    this.getOrgLeIdList();
    this.statutorySettingCheck();
    this.socket = new WebSocket(process.env.VUE_APP_WEBSOCKET);
      this.socket.addEventListener('open', (event) => {
        console.log('WebSocket connection opened');
    });

    this.socket.addEventListener('message', (event) => {
      // console.log(JSON.parse(event.data));
      
      // document.getElementById('websocket').innerHTML=event.data;
      // const { id, name } = event.data;
      // let actives = dataArray.filter((item) =>{
      //   //let result =  arr.find( x => x.legal_entity_id == item.data.legal_entity_id )
      //   if (item.progress < 100) {
      //     return item
      //   }
      // })
      // console.log("Actives",actives)
      // let completed = dataArray.filter((item) =>{
      //   //let result =  arr.find( x => x.legal_entity_id == item.data.legal_entity_id )
      //   if(item.progress == 100)
      //     return item
      // })
      let dataArray = JSON.parse(event.data);
      let completed = [] 
      this.entities.filter(item => {
        let result = dataArray.find( x => x.data.legal_entity_id == item.id)
        if(result && result.progress == 100)
           completed.push(result)
      })
      let actives = []
      this.entities.filter(item => {
        let result = dataArray.find( x => x.data.legal_entity_id == item.id)
        if(result && result.progress < 100)
           actives.push(result)
      })
      
      this.actives = actives;
      this.completed = completed
      if(event.data == null){
        this.socket.addEventListener('close', (event) => {
        console.log('WebSocket connection closed');
      });
      }
    });
    // this.fetchITdeclarationEnabledFlag()
  },
  methods: {
    ...mapActions({
      act_statutory_settings: "dashboard/payroll/monthlypayroll/lockPayroll/getStatutorySettingsCheck",
      act_fetch_declarationFlag: "dashboard/payroll/monthlypayroll/lockPayroll/getDeclarationFlag",
      
      act_incorporate_declaration:"dashboard/payroll/monthlypayroll/lockPayroll/incorporateDeclaration",
      act_setPayrollMonth: "payroll/runpayroll/setPayrollMonth",
      act_payroll_cycle_data: "onboard/settings/payroll_cycle/fetchAll",
      act_lockPayroll: 'dashboard/payroll/monthlypayroll/lockPayroll/lock',
      act_unlockPayroll: 'dashboard/payroll/monthlypayroll/lockPayroll/unlock',
      act_getPayData: 'dashboard/payroll/monthlypayroll/lockPayroll/getTotalPay',
      act_getLockedPayrollMonth: 'dashboard/payroll/monthlypayroll/lockPayroll/getLockedPayrollMonth',
      act_release_payslip_ess: 'dashboard/payroll/monthlypayroll/lockPayroll/releasePayslipESS',
      act_release_itproof:"dashboard/itProof/releaseItproofForPayrollMonth",
      act_fetch_incorparation_validation_data: "dashboard/itProof/fetchItProofDataForIncorparationDate",
      act_release_it_sheet_ess: 'dashboard/payroll/monthlypayroll/lockPayroll/releaseITSheetESS',
      act_get_payroll_reports_generation_flag: 'dashboard/payroll/monthlypayroll/lockPayroll/getPayrollReportGenerationFlag'
      // act_fetch_declarationFlag: "dashboard/itProof/fetchDeclarationFlag"
    }),

    ...mapActions({
      getOrgLeList: "onboard/organization/getOrgLeIdList",
      act_fetchAll: "onboard/statutoryinfo/incometax/fetchAll"
    }),

    /** To fetch First payroll run month:year for that particular LE &&
     * To set the Financial Year list
    */
  //  async fetchITdeclarationEnabledFlag(){
  //   let response = await this.act_fetchAll(this.le_id);
  //      console.log("ressssssssssssssssssssssssssssssssSSS",response)
  //      if(response.data.payload.data.submissionSettings.releaseITProof = true){
  //       console.log("inside if",this.enableITProofReleaseButton)
  //       this.enableITProofReleaseButton = true
  //      }else if(response.data.payload.data.submissionSettings.releaseITProof = false)
  //      {
  //       console.log("else if",this.enableITProofReleaseButton)
  //      this.enableITProofReleaseButton = false
  //      }
  //  },
   async functiontoCheckEmployeeSavedAsDraft(){
       if(this.IncorporationValidationData.auditValidationPending > 0){
         this.auditPendingFlag = false
         this.releaseItProofForThisMonthPayrollFlag = false
         this.incorporationDateIsDraftValidation = true
         this.incorporationValidationMessage = `${this.IncorporationValidationData.auditValidationPending} Employees Audit is Pending from Auditor.Please Audit `
       }
       if(this.IncorporationValidationData.auditValidationPending == 0){
          this.releaseItProofForPayroll=!this.releaseItProofForPayroll
        }
  },
   async releaseItproofValidation(){
    this.releaseItProofForPayroll = false
       if(this.IncorporationValidationData.savedAsDraft > 0){
        this.incorporationDateIsDraftValidation = true
        this.incorporationValidationMessage = `${this.IncorporationValidationData.savedAsDraft} Employees were saved as Draft`
       }
       else if(this.IncorporationValidationData.savedAsDraft == 0){
       this.releaseItProofForThisMonthPayrollFlag = true
       this.releaseItProofForThisMonthPayroll()
       }
    },
   async functiontoIncorporateDeclaration1 (){
      try{
      this.releaseItProofForPayroll = false
     
      let payload={
        legalEntityId:this.le_id,
        financialYear: "2024",
        //get it from localstorage
        enabledBy:localStorage.getItem("loginId")
      }
       let res = await this.act_incorporate_declaration(payload)
        if (res) {
          this.showIncorporateDeclaration=false
          //  this.itProofReleasedForThisMonthPayroll = true
           this.showSuccessMsg = true;
           this.successMessage = "Successfully Incorporated the Declaration"
         }
     } catch(err){
        this.toast=true
        this.errmsg = err
        this.incorporationDate = false
     }
  },
   async functiontoIncorporateDeclaration (){
      try{
      this.releaseItProofForPayroll = false
     
      let payload={
        legalEntityId:this.le_id,
        financialYear:localStorage.getItem("financialYear"),
        enabledBy:localStorage.getItem("loginId")
      }
       let res = await this.act_fetch_declarationFlag(payload)
        if (res) {
          this.showIncorporateDeclaration=false
          //  this.itProofReleasedForThisMonthPayroll = true
           this.showSuccessMsg = true;
           this.successMessage = "Successfully Incorporated the Declaration"
         }
     } catch(err){
        this.toast=true
        this.errmsg = err
        this.incorporationDate = false
     }
  },

  async generateReports(){
    if(this.selectmonth){
      let generationStatus = await this.getPayrollReportsGenerationStatus();
      if(generationStatus.payrollStatus){
        this.showReportModal = true;
        this.generatePayload = {
          month: this.selectmonth,
          year: this.selectYear.toString(),
        }
      }else{
        this.toast = true;
        this.errmsg = generationStatus.statusMessage;
      }
    }else{
      this.toast = true;
      this.errmsg = "Please select a month to generate Payslip and Tax sheet"
    }
  },

  async getPayrollReportsGenerationStatus(){
    try {
      let obj = {
        legal_entity_id : this.le_id,
        month : this.selectmonth,
        financial_year: this.selectYear.toString()
      }
      let response = await this.act_get_payroll_reports_generation_flag(obj);
      console.log(response.data, 'response');
      if(response && response.data){
        return {
          payrollStatus: response.data.payload.data,
          statusMessage: response.data.message
        }
      }
    } catch (error) {
      this.toast=true
      this.errmsg = err
    }
  },

  closeReportModal(){
    this.showReportModal = false;
  },

   async releaseItProofForThisMonthPayroll(){
     try{
      this.releaseItProofForPayroll = false
     
      let payload={
        legalEntityId:this.le_id,
        financialYear:"2025",
        approvedBy:localStorage.getItem("loginId")
      }
       let res = await this.act_release_itproof(payload)
         if(res){
           this.itProofReleasedForThisMonthPayroll = true
           this.showSuccessMsg = true;
           this.successMessage = "Successfully released It Proof Data for this month  payroll"
         }
     } catch(err){
        this.toast=true
        this.errmsg = err
        this.incorporationDate = false
     }
   },
    async fetchIncorporation(){
      try{
       let payload={
        legalEntityId:this.le_id,
        financialYear:"2025"
       }
       let res = await this.act_fetch_incorparation_validation_data(payload)
         if(res.payload){
          this.IncorporationValidationData = res.payload
         }
      }catch(err){

      }
    },
      async fetchDeclarationFlag(){
      try{
       let payload={
        legalEntityId:this.le_id,
       
       }
        let res = await this.act_fetch_declarationFlag(payload)
        if (res.data.payload) {
          this.declarationFlag = res.data.payload
         }
      }catch(err){

      }
    },
    async fetchPayrollCycleData() {
      try {
        let res = await this.act_payroll_cycle_data(this.le_id);
        if (res.data.status && res.data.payload.data) {
          this.firstPayrollDate = res.data.payload.data.firstPayroll;
          let startingYear = new Date(this.firstPayrollDate).getFullYear();
          let startingMonth = new Date(this.firstPayrollDate).getMonth() + 1;
          let firstPayrollMonth;
          let currentYear = new Date().getFullYear();
          let currentMonth = new Date().getMonth() + 1;
          if (!!!this.selectYear) {
            this.setCurrentMonthIndex(new Date(this.firstPayrollDate).getMonth());
            this.selectmonth = this.payrollMonths[this.currentMonthIndex][0];
            this.selectYear = startingYear;
            let obj = {
              month: this.selectmonth.name,
              year: this.selectYear.toString(),
            };
            await this.act_setPayrollMonth(obj);
          }
          if(!!!this.previousMonth) {
            firstPayrollMonth = startingMonth;
          } else{
            firstPayrollMonth = this.previousMonth;
          }
          // else {
          //   startingYear = this.selectYear;
          //   startingMonth = new Date(this.firstPayrollDate).getMonth() + 1;
          //   currentYear = startingYear + 1;
          //   let currentMonth = new Date().getMonth() + 1;
          // }
         
          this.financialYearsList = this.getFinancialYearsRange(
            this.selectYear.toString() +
              "-" +
              firstPayrollMonth.toString() +
              "-" +
              "01",
            currentYear.toString() + "-" + currentMonth.toString() + "-" + "01"
          );
          
          this.getLockedPayrollMonth();
           //To set
          // Change of financial year in not allowed by clicking prev/next
          // Therefore this.currentFinancialYearIndex value remains 0 by default
          // this.currentFinancialYearIndex = this.financialYearsList.length
          //   ? this.financialYearsList.length - 1
          //   : 0;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    redirectToFbpLock(){
      this.$router.push(`/dashboard/${this.$route.params.entity_index}/payroll/fbpPayroll/fbpLock`)
    },

    async statutorySettingCheck() {
      try {
        let res = await this.act_statutory_settings(this.le_id);
        console.log("res==",res)
        this.statutoryFlag = res.data.payload
        
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    onReleasePayslip(){
      this.showReleasePayslip = true;
      this.popupmessage = "Are you sure you want to release payslip to ESS"
    },

    onReleaseITSheet(){
      this.showReleaseITSheet = true;
      this.popUpMessage = "Are you sure you want to release it sheet to ESS"
    },

    cancelRelease(){
      this.showReleasePayslip = false;
    },

    cancelReleaseITSherrt() {
      this.showReleaseITSheet = false;
    },
   onIncorporateDeclaration(){
      this.showIncorporateDeclaration = true;
      this.popupmessage = "Are you sure you want to Incorporate Declaration ?"
    },

    cancelIncorporation(){
      this.showIncorporateDeclaration = false;
    },
    async releaseITSheet() {
      try {
        if(this.selectmonth) {
          let obj = {
            le_id : this.le_id,
            financial_year: this.payrollYear,
            month: this.selectmonth.toLocaleLowerCase().substring(0,3)
          }
          let res = await this.act_release_it_sheet_ess(obj);
          if(res.status){
            this.showReleaseITSheet = false;
            this.showSuccessMsg = true;
            this.successMessage = "Successfully released it sheet to ESS"
          }
        } else {
          this.showReleaseITSheet = false;
          this.toast = true;
          this.errmsg = "Please select a month to release it sheet"
        }
      } catch (error) {
        this.showReleaseITSheet = false;
        this.toast = true;
        this.errmsg = error
      }
    },
    async releasePayslip(){
      try {
        if(this.selectmonth){
          console.log(this.payrollYear);
          let obj = {
            le_id : this.le_id,
            financial_year: this.payrollYear,
            month: this.selectmonth.toLocaleLowerCase().substring(0,3)
          }
          let res = await this.act_release_payslip_ess(obj)
          if(res.status){
            this.showReleasePayslip = false;
            this.showSuccessMsg = true;
            this.successMessage = "Successfully released payslip to ESS"
          }
        }else{
          this.showReleasePayslip = false;
          this.toast = true;
          this.errmsg = "Please select a month to release payslip"
        }
      } catch (error) {
        this.showReleasePayslip = false;
        this.toast = true;
        this.errmsg = error
      }
    },

    gotoPayroll(){
      this.showSuccessMsg = false;
      window.location.reload();
    },

    setNextPayrollMonth() {
      if (this.currentMonthIndex == 11) {
        this.currentMonthIndex = 0;
      } else {
        this.currentMonthIndex += 1;
        if (this.currentMonthIndex == 9) {

          this.selectYear = Number(this.selectYear) + Number(1);
        }
      }
      let obj = {
        month : this.payrollMonths[this.currentMonthIndex][0].name,
        year : this.selectYear.toString(),
      }
      this.act_setPayrollMonth(obj);
    },

    setPreviousMonth() {

    },

    getPreviousMonth(date) {
      if (date.getMonth() == 0) {
          return new Date(date.getFullYear() - 1, 11, 1);
      } else {
          return new Date(date.getFullYear(), date.getMonth() - 1, 1);
      }
    },

    getNextMonth(date) {
      if (date.getMonth() == 11) {
          return new Date(date.getFullYear() + 1, 0, 1);
      } else {
          return new Date(date.getFullYear(), date.getMonth() + 1, 1);
      }
    },

    /** To set the Financian years available between a range of dates */
    getFinancialYearsRange(startDate, endDate) {
      try {
        var start = startDate.split("-");
        var end = endDate.split("-");
        var startYear = parseInt(start[0]);
        var endYear = parseInt(end[0]);
        var dates = [];
        var fyNamesArray = [];
        if (startYear === endYear) {
          if (Number(start[1]) > 3) {
            fyNamesArray.push({
              name: startYear.toString() + "-" + (startYear + 1).toString()
            });
          } else if (Number(start[1]) < 4 && Number(end[1]) < 4) {
            fyNamesArray.push({
              name: (startYear - 1).toString() + "-" + startYear.toString()
            });
          } else {
            fyNamesArray.push({
              name: (startYear - 1).toString() + "-" + startYear.toString()
            });
            fyNamesArray.push({
              name: startYear.toString() + "-" + (startYear + 1).toString()
            });
          }
        } else {
          var i;
          for (i = startYear; i <= endYear; i++) {
            var endMonth = i != endYear ? 11 : parseInt(end[1]) - 1;
            var startMon = i === startYear ? parseInt(start[1]) - 1 : 0;
            let fyObj = {};
            fyObj.name =
              startMon > 2
                ? i.toString() + "-" + (i + 1).toString()
                : (i - 1).toString() + "-" + i.toString();
            fyNamesArray.push(fyObj);
          }
          if (Number(end[1]) > 3) {
            fyNamesArray.push({
              name: (i - 1).toString() + "-" + i.toString()
            });
          }
        }
        return fyNamesArray;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /** On Previous year FY Click  */
    onPrevFYClick() {
      try {
        this.currentFinancialYearIndex = this.currentFinancialYearIndex - 1;
        this.currentMonthIndex = 11;
        this.selectmonth = "";
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /** On Next year FY Click  */
    onNextFYClick() {
      try {
        this.currentFinancialYearIndex = this.currentFinancialYearIndex + 1;
        if (
          (this.financialYearsList.length &&
            this.financialYearsList.length - 1) ==
          this.currentFinancialYearIndex
        ) {
          this.setCurrentMonthIndex();
        } else {
          this.currentMonthIndex = 11;
        }
        this.selectmonth = "";
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /** To fetch the current month Index from a set months in a Financial Year */
    setCurrentMonthIndex(month) {
      try {
      let monthIndex = (month || month == 0) ? month : new Date().getMonth();
        switch (monthIndex) {
          case 0:
            this.currentMonthIndex = 9;
            break;
          case 1:
            this.currentMonthIndex = 10;
            break;
          case 2:
            this.currentMonthIndex = 11;
            break;
          case 3:
            this.currentMonthIndex = 0;
            break;
          case 4:
            this.currentMonthIndex = 1;
            break;
          case 5:
            this.currentMonthIndex = 2;
            break;
          case 6:
            this.currentMonthIndex = 3;
            break;
          case 7:
            this.currentMonthIndex = 4;
            break;
          case 8:
            this.currentMonthIndex = 5;
            break;
          case 9:
            this.currentMonthIndex = 6;
            break;
          case 10:
            this.currentMonthIndex = 7;
            break;
          case 11:
            this.currentMonthIndex = 8;
            break;
          default:
            break;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    getCurrentMonthIndex(monthName) {
      try {
        switch (monthName) {
          case 'jan':
            this.currentMonthIndex = 9;
            break;
          case 'feb':
            this.currentMonthIndex = 10;
            break;
          case 'mar':
            this.currentMonthIndex = 11;
            break;
          case 'apr':
            this.currentMonthIndex = 0;
            break;
          case 'may':
            this.currentMonthIndex = 1;
            break;
          case 'jun':
            this.currentMonthIndex = 2;
            break;
          case 'jul':
            this.currentMonthIndex = 3;
            break;
          case 'aug':
            this.currentMonthIndex = 4;
            break;
          case 'sep':
            this.currentMonthIndex = 5;
            break;
          case 'oct':
            this.currentMonthIndex = 6;
            break;
          case 'nov':
            this.currentMonthIndex = 7;
            break;
          case 'dec':
            this.currentMonthIndex = 8;
            break;
          default:
            break;
        }
        return this.currentMonthIndex;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /** To set the Month year to display in UI  */
    setMonthFiscalYear(month) {
      try {
        var today = new Date();
        if (
          this.financialYearsList.length &&
          this.currentFinancialYearIndex > -1
        ) {
          let switchedFinancialYear = this.financialYearsList[
            this.currentFinancialYearIndex
          ].name.split("-");
          if (month == "January" || month == "February" || month == "March") {
            return switchedFinancialYear[1];
          } else {
            return switchedFinancialYear[0];
          }
        } else {
          return "";
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /** On click of left button beside a month in UI to change a month to run payroll in a FY  */
    onPrevMonthClick() {
      try {
        this.currentMonthIndex -= 1;
        this.selectmonth = "";
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /** On click of right button beside a month in UI to change a month to run payroll in a FY  */
    onNextMonthClick() {
      try {
        this.currentMonthIndex += 1;
        this.selectmonth = "";
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /** On click of a month in UI to run payroll in a FY  */
    onMonthSelection(mon) {
      this.selectmonth = mon;
    },

    /** To fetch current of a FY */
    currentmonth() {
      try {
        if (this.selectmonth == "") {
          this.selectmonth.name = this.months[new Date().getMonth()];
        } else return this.selectmonth.name;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    postLock() {
      this.showLockPopup = true;
    },
    cancel(params) {
      this.showLockPopup = false;
      this.showUnlockBtn = true;
      this.releaseItProofForPayroll = false;
      this.incorporationDate = false;
      this.incorporationDateIsDraftValidation = false; 
      if( params == "checkIsAuditApproved"){
        this.fetchIncorporation();
      }
    },
    yes() {
      this.showLockPopup = false;
      this.showUnlockBtn = true;
    },
    postUnlock() {
      this.showUnlockPopup = true;
    },
    cancelUnlockPayroll() {
      this.showUnlockPopup = false;
      this.showUnlockBtn = false;
    },
    submitUnlockPayroll() {
      this.showUnlockPopup = false;
      this.showUnlockBtn = false;
    },
    back() {
      this.unlockMonthPopup = false;
    },
    publishReports() {
      //this.showPublishPopup = true;
    },
    viewReports() {
      try {
        this.$router.push(
          `/dashboard/${this.$route.params.entity_index}/reports/reportsDashboard/myReports`
        );
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    cancelAdd() {
      this.showPublishPopup = false;
    },
    addPopup() {
      this.showPublishPopup = false;
    },

    async lockPayroll() {
      try {
        let obj = {
          'le_id': this.le_id,
          'month': this.selectmonth.substr(0, 3).toLowerCase(),
          'year': this.selectYear.toString(),
          'lock': "1",
          'unlock': "0"
        };
        let res = await this.act_lockPayroll(obj);
        this.showLockPopupModal = false;
          this.getLockedPayrollMonth();
          this.fetchPayrollCycleData();
      
        // this.postLock();
      } catch (err) {
        this.showLockPopupModal = false;
        this.toast = true;
        this.errmsg = err;
      }
    },


    async unlockPayroll() {
      try {
        let currentMonthIndex = this.getCurrentMonthIndex(this.selectmonth.substr(0, 3).toLowerCase());
        let selectmonth = currentMonthIndex == 0 ? this.payrollMonths[11][0].name : this.payrollMonths[currentMonthIndex-1][0].name;
        let selectYear = (currentMonthIndex == 9 ? this.selectYear -1 : this.selectYear);
        let obj = {
          'le_id': this.le_id,
          'month': selectmonth.substr(0, 3).toLowerCase(),
          'year': selectYear.toString(),
          'lock': "0",
          'unlock': "1"
        };
        await this.act_unlockPayroll(obj);
        this.getLockedPayrollMonth();
        // this.postUnlock();
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },


    async getPayData() {
      try {
        // let obj = {
        //   'le_id': this.le_id,
        //   'month': this.selectmonth.substr(0, 3).toLowerCase(),
        //   'year': this.selectYear.toString()
        // };
        let obj = {
          'le_id': this.le_id,
          'month': this.payrollMonth.slice(0, 3).toLowerCase(),
          'year': this.payrollYear
        };
        let res = await this.act_getPayData(obj);
        let resData = res.data.payload;
        if (resData) {
          this.grossPay = resData.grossPay;
          this.totalDeduction = resData.totalDeduction == null ? 0 : resData.totalDeduction;
          this.totalPay = resData.totalPay == null ? 0 : resData.totalPay;
        }
      } catch (err) {
        this.errmsg = err;
      }
    },

    async getLockedPayrollMonth() {
      try {
        let obj = {
          'le_id': this.le_id
        };

        let res = await this.act_getLockedPayrollMonth(obj);
        if (res && res.data && res.data.payload && res.data.payload.data) {
          let lockPayrollData = res.data.payload.data[0];
          this.getCurrentMonthIndex(lockPayrollData.month);
          this.selectYear = lockPayrollData.financial_year;
          this.previousPayrollMonth = lockPayrollData.month;
          if(this.previousPayrollMonth == "dec"){
            this.previousMonth = 1
          }else{
            this.previousMonth = this.getMonthCodeByValue(this.previousPayrollMonth) +1;
          }
          if (lockPayrollData.last_payroll_locked) {
            this.setNextPayrollMonth();
          }
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },


    /** On click of a Run Payroll button */
    async onRunPayrollClick(btnText) {
      try {
        if (btnText == "RUN PAYROLL") {
          if (this.selectmonth) {
            this.errmsg = "";
            this.toast = false;
            let currentdate = new Date();
            let selectedMonthYear = null;
            let switchedFinancialYear = this.financialYearsList[
            this.currentFinancialYearIndex
            ].name.split("-");
            selectedMonthYear = (this.selectmonth == "January" ||
              this.selectmonth == "February" ||
              this.selectmonth == "March"
              ? switchedFinancialYear[1]
              : switchedFinancialYear[0]
            )
            let obj = {
              month: this.selectmonth,
              year: this.selectYear.toString(),
            };
            let isBeyondFirstPayrollRun = this.checkIsSelectedMonthBeyondFirstPayrollRunOnPaylief(
              this.selectmonth == "January" ||
                this.selectmonth == "February" ||
                this.selectmonth == "March"
                ? {
                    month: this.selectmonth,
                    year: Number(selectedMonthYear) + 1
                  }
                : { month: this.selectmonth, year: selectedMonthYear }
            );
            if (isBeyondFirstPayrollRun) {
              this.errmsg =
                "You can't run payroll beyond first payroll month for this Legal Entity";
              this.toast = true;
              return;
            }

            let isSelectedMonthBeyondFuture = this.checkIsSelectedMonthToRunPayrollOfFuture(
              this.selectmonth,
              this.selectmonth == "January" ||
                this.selectmonth == "February" ||
                this.selectmonth == "March"
                ? switchedFinancialYear[1]
                : switchedFinancialYear[0]
            );

            if (!isSelectedMonthBeyondFuture) {
              this.errmsg = "You can't run payroll for future month";
              this.toast = true;
              return;
            }

            try {
              await this.act_setPayrollMonth(obj);
              this.$router.push(
                `/payroll/run/${this.$route.params.entity_index}/paygroups`
              );
            } catch (err) {
              this.toast = true;
              this.errmsg = err.message;
            }
          } else {
            this.errmsg = "Please select a month to run payroll";
            this.toast = true;
          }
        }
        if (btnText == "UNLOCK PAYROLL") {
          this.unlockMonthPopup = true;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    async runOffCyclePayroll() {
      try {
          if (this.selectmonth) {
            this.errmsg = "";
            this.toast = false;
            let currentdate = new Date();
            let selectedMonthYear = null;
            let switchedFinancialYear = this.financialYearsList[
            this.currentFinancialYearIndex
            ].name.split("-");
            selectedMonthYear = (this.selectmonth == "January" ||
              this.selectmonth == "February" ||
              this.selectmonth == "March"
              ? switchedFinancialYear[1]
              : switchedFinancialYear[0]
            )
            let obj = {
              month: this.selectmonth,
              year: selectedMonthYear
            };
            let isBeyondFirstPayrollRun = this.checkIsSelectedMonthBeyondFirstPayrollRunOnPaylief(
              this.selectmonth == "January" ||
                this.selectmonth == "February" ||
                this.selectmonth == "March"
                ? {
                    month: this.selectmonth,
                    year: Number(selectedMonthYear) + 1
                  }
                : { month: this.selectmonth, year: selectedMonthYear }
            );
            if (isBeyondFirstPayrollRun) {
              this.errmsg =
                "You can't run payroll beyond first payroll month for this Legal Entity";
              this.toast = true;
              return;
            }

            let isSelectedMonthBeyondFuture = this.checkIsSelectedMonthToRunPayrollOfFuture(
              this.selectmonth,
              this.selectmonth == "January" ||
                this.selectmonth == "February" ||
                this.selectmonth == "March"
                ? switchedFinancialYear[1]
                : switchedFinancialYear[0]
            );

            if (!isSelectedMonthBeyondFuture) {
              this.errmsg = "You can't run payroll for future month";
              this.toast = true;
              return;
            }

            try {
              await this.act_setPayrollMonth(obj);
              this.$router.push({
                path: `/payroll/run/${this.$route.params.entity_index}/selectedEmployee`,
                query: { record: "offPayroll" }
            });
            } catch (err) {
              this.toast = true;
              this.errmsg = err.message;
            }
          } else {
            this.errmsg = "Please select a month to run payroll";
            this.toast = true;
          }
        // if (btnText == "UNLOCK PAYROLL") {
        //   this.unlockMonthPopup = true;
        // }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /** Check whether the selected month is future month of that FY */
    checkIsSelectedMonthToRunPayrollOfFuture(selectedmonth, selectedMonthYear) {
      try {
        let currentdate = new Date();
        let currentMonth = currentdate.getMonth();
        let currentYear = currentdate.getFullYear();
        let selectedMonthCode = this.getMonthCodeByName(selectedmonth);

        let startingYear = new Date(this.firstPayrollDate).getFullYear();
        let startingMonth = new Date(this.firstPayrollDate).getMonth() + 1;

        if (currentYear == selectedMonthYear) {
          if (currentMonth >= selectedMonthCode) {
            return true;
          } else {
            return false;
          }
        } else if (currentYear > selectedMonthYear) {
          return true;
        } else return false;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /** Check whether the selected month is beyond the first payroll month of that LE */
    checkIsSelectedMonthBeyondFirstPayrollRunOnPaylief(obj) {
      let startingYear = new Date(this.firstPayrollDate).getFullYear();
      let startingMonth = new Date(this.firstPayrollDate).getMonth() + 1;
      let selectedYear = Number(obj.year);
      let selectedMonth = Number(this.getMonthCodeByName(obj.month)) + 1;
      let isPayrollMonthBeyondFirstPayrollMonth = false;

      if (selectedYear == startingYear) {
        if (selectedMonth > startingMonth) {
          return false;
        } else {
          if (selectedMonth == startingMonth) return false;
        }
      }
      if (selectedYear > startingYear) {
        return false;
      } else {
        return true;
      }
    },

    getMonthCodeByName(monthName) {
      try {
        switch (monthName) {
          case "January":
            return 0;
          case "February":
            return 1;
          case "March":
            return 2;
          case "April":
            return 3;
          case "May":
            return 4;
          case "June":
            return 5;
          case "July":
            return 6;
          case "August":
            return 7;
          case "September":
            return 8;
          case "October":
            return 9;
          case "November":
            return 10;
          case "December":
            return 11;
          default:
            return "";
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    getMonthCodeByValue(monthName) {
      try {
        switch (monthName) {
          case "jan":
            return 1;
          case "feb":
            return 2;
          case "mar":
            return 3;
          case "apr":
            return 4;
          case "may":
            return 5;
          case "jun":
            return 6;
          case "jul":
            return 7;
          case "aug":
            return 8;
          case "sep":
            return 9;
          case "oct":
            return 10;
          case "nov":
            return 11;
          case "dec":
            return 12;
          default:
            return "";
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    async getOrgLeIdList() {
      const org = this.orgIds;
      const le = this.le_id;
      //console.log("Org:",org);
      //console.log("Le ID",le);
      let bodyParams = {};
      let  data = await this.getOrgLeList({
        data: {
            ...bodyParams
        }
      });
      this.role = data.data.user.userRole;
      this.payrollDashboardsValue = data.data.user.permissions.payroll_dashboards ? true : false;
      //console.log("PL-3406",data);
    },
    async confirm() {
      try {
      this.showLockPopupModal = true;
      //this.showUnlockBtn = true;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    no() {
      this.showLockPopupModal = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../../../scss/components/btn.scss";

.title {
  padding: 20px;
}
.quarter {
  display: flex;
  justify-content: center;
  font-size: 18px;
  padding-top: 10px;
  .dot {
    line-height: 15px;
    //   font-size: 16px;
    padding: 0px 5px;
  }
  .year {
    font-size: 16px;
    color: #6e6e6e;
    line-height: 25px;
  }
}

.financialYears {
  display: flex;
  justify-content: center;
  .prevFYyear {
    height: 20px;
    // position: relative;
    top: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px 15px 0px 0px;
    cursor: pointer;
  }
  .nextFYyear {
    height: 20px;
    // position: relative;
    top: 60px;
    display: flex;
    padding: 5px 0px 0px 15px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
}
.quartermonths {
  display: flex;
  justify-content: center;
  .prevmonth {
    height: 45px;
    position: relative;
    top: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 15px;
    cursor: pointer;
  }
  .nextmonth {
    height: 45px;
    position: relative;
    top: 60px;
    display: flex;
    padding: 15px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .month {
    // width: 153px;
    // height: 100px;
    border-radius: 12px;
    display: flex;
    padding: 35px;
    // flex-direction: column;
    background-color: #f9f9f9;
    margin-right: 20px;
    margin-left: 20px;
    margin-top: 40px;
    margin-bottom: 40px;
    background-color: #f9f9f9;
    justify-content: center;
    align-items: center;
    color: #646464;
    font-size: 20px;
    font-weight: 600;
    .subtext {
      font-size: 16px;
      margin-top: 5px;
      margin-left: 5px;
      font-weight: 400;
    }
    img {
      position: relative;
      top: -45px;
      left: 15px;
    }
  }
  .selected {
    height: 120px;
    display: flex;
    flex-direction: column;
    border-radius: 14.4px;
    margin-top: 30px;
    background-color: #34c0be;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    span {
      font-size: 26px;
      font-weight: 600;
    }
    .subtext {
      font-size: 16px;
      margin-top: 5px;
      margin-left: 5px;
      font-weight: 400;
    }
    img {
      position: relative;
      top: -30px;
      left: 30px;
    }
    .paydate {
      background-color: #c0edeb;
      padding: 10px 10px;
      font-weight: 300px;
      margin-top: 10px;
      font-size: 14px;
      width: 100%;
      color: black;
      span {
        font-size: 16px;
        font-weight: 300;
      }
      img {
        position: relative;
        top: -30px;
        left: 30px;
      }
      // .Total_list{
      //   display: flex;
      //   flex-direction: column;
      // }
    }
  }
}
.grid-container{
  display: flex;
  position: relative;
  // z-index: 3;
  flex-wrap: wrap;
  margin-bottom: 32px;
  background: #ffffff;
  >:nth-child(n) {
    margin-right: 32px;
  }
  >:last-child {
    margin-right: 0px;
  }
}
.run {
  display: flex;
  justify-content: center;
  margin: 20px 0px 20px 0px;
}
.runie {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
   margin: 20px 0px 20px 0px;
}
.purple {
  margin-right: 16px;
  border-radius: 4px;
}
.bottom {
  display: flex;
  margin-top: 35px;
  border-bottom: 2px solid #eeeeee;
  border-top: 2px solid #eeeeee;
  padding: 10px 100px 10px 100px;
  div {
    flex: 1;
    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #6e6e6e;
    padding-top: 15px;
    .increase {
      color: #1db25f;
      font-size: 10px;
      margin-left: 20px;
      b {
        font-size: 14px;
      }
    }
  }
}
// completed and active css
.Total_list{
  display: flex;
  justify-content: space-evenly;
  padding: 10px 20px;
  font-size: 12px;
}
table{
  width: 100%;
  border-collapse: collapse;
}
th{
  text-align: center;
background-color: #e2e2e2;
padding: 10px 15px;
}
td{
  border-bottom: 2px solid #E5E5E5;
  padding: 8px;
  text-align: center;
  // border: none;
  font-weight: 500;
}

td:last-child{
  border: none;
}

.active-bar > progress::-webkit-progress-value{
  background-color: #2780fd;
  border-radius: 10px;
}

progress::-webkit-progress-bar{
  background-color: #e2e2e2;
  border-radius: 10px;
}

.complete-bar > progress::-webkit-progress-value{
  background-color: #00b430;
  border-radius: 10px;
}
.reports {
  display: flex;
  justify-content: space-around;
  div {
    flex: 1;
    flex-grow: 1;
    padding: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #6e6e6e;
    color: #5d409f;
    border-right: 2px solid #eeeeee;
    cursor: pointer;
    &:hover {
      background-color: #dadada;
    }
  }
}
.running {
  display: flex;
  justify-items: center;
  align-content: center;
  height: 500px;
  font-size: 22px;
}
.btn.secondary{
  color: #5d409f !important;
  border:#5d409f solid 1px !important;

}
.btn-popup {
  display: block;
  border-radius: 4px;
  min-width: 150px;
  padding: 0px 10px;
  height: 35px;
  background-color: #5d409f;
  color: #ffffff;
}
.btn-popup-secondary {
  display: block;
  border-radius: 4px;
  min-width: 150px;
  padding: 0px 10px;
  height: 35px;
  background-color: #ffffff;
  border: #34c0be solid 1px;
  color: #34c0be;
}
.popupClass {
  height: 527px;
}
.custom-width {
  width: 430px;
  // height: 128px;
  margin-top: 20px;
  margin-bottom: 20px;
  border-radius: 4px;
  // border: solid 1px #dadada;
  background-color: #ffffff;
}
.popupdetails {
  font-size: 16px;
  text-align: center;
  color: #6e6e6e;
  margin-top: 20px;
}
.modal {
  display: block;
  position: fixed;
  z-index: 6;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.3);
}

.modal-content-history {
  background-color: white;
  margin: 60px auto 0px auto;
  z-index: 20;
  width: 500px;
  height: 335px;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  position: relative;
}
.top-bar {
  background-color: #34c0be;
  display: flex;
  position: absolute;
  width: 100%;
  height: 50px;

  span {
    font-size: 22px;
    font-weight: bold;
    padding: 10px;
    color: #ffffff;
  }
}
.quick-links{
    background: white;
    flex-grow: 1;
    flex: 1;
    width: 25%;
    // width: auto;
     margin-bottom: 32px;
    height: auto;
    border: 2px solid #eeeeee;
    border-radius: 8px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06);
}

.head-count{
    flex-grow: 5;
    flex: 5;
    background: white;
    width: 75%;
    margin-bottom: 32px;
    margin-right: 30px;
    // width: auto;
    height: auto;
    min-height: 500px;
    border: 2px solid #eeeeee;
    border-radius: 8px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06);
}
.payroll{
    background: white;
    width: 5%;
    flex: 2;
    height: auto;
    flex-grow: 2;
    border: 2px solid #eeeeee;
    border-radius: 8px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06);
}
.btnGrp {
  margin-top: 60px;
  margin-left: 35px;
}
.customButton{
    display: block;
    border-radius: 4px;
    background-color: #ffffff;
    border: purple solid 1px;
    color:purple;
    font-weight: bold;
    width:90%;
    min-height: 45px;
    padding: 14px;
}
.popupRadios {
  padding: 105px 0 0 30px;
  display: flex;
  justify-content: space-between;
}
.popupradio {
  padding: 40px 0 0 30px;
}
</style>
